(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8196],{

/***/ 43581:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[slug]",
      function () {
        return __webpack_require__(54543);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderBreadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs.js





// next

// @mui

// ----------------------------------------------------------------------
Breadcrumbs_Breadcrumbs.propTypes = {
    activeLast: (prop_types_default()).bool,
    links: (prop_types_default()).array.isRequired
};
function Breadcrumbs_Breadcrumbs(_param) {
    var links = _param.links, _activeLast = _param.activeLast, activeLast = _activeLast === void 0 ? false : _activeLast, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "activeLast"
    ]);
    var currentLink = links[links.length - 1].name;
    var listDefault = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
            link: link
        }, link.name);
    });
    var listActiveLast = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                marginBottom: 5
            },
            children: link.name !== currentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
                link: link
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    maxWidth: 260,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    color: "text.disabled",
                    textOverflow: "ellipsis"
                },
                textTransform: "inherit",
                children: currentLink
            })
        }, link.name);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: {
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "text.disabled"
            }
        }),
        style: {
            alignItems: "center"
        }
    }, other), {
        children: activeLast ? listDefault : listActiveLast
    }));
}
// ----------------------------------------------------------------------
LinkItem.propTypes = {
    link: prop_types_default().shape({
        href: (prop_types_default()).string,
        icon: (prop_types_default()).any,
        name: (prop_types_default()).string
    })
};
function LinkItem(param) {
    var link = param.link;
    var _href = link.href, href = _href === void 0 ? "" : _href, name = link.name, icon = link.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            variant: "body2",
            sx: {
                lineHeight: 2,
                display: "flex",
                alignItems: "center",
                color: "grey.600",
                "& > div": {
                    display: "inherit"
                }
            },
            textTransform: "inherit",
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mr: 1,
                        "& svg": {
                            width: 20,
                            height: 20
                        }
                    },
                    children: icon
                }),
                name
            ]
        }, name)
    });
}

// EXTERNAL MODULE: ./src/components/Iconify.js + 1 modules
var Iconify = __webpack_require__(34444);
;// CONCATENATED MODULE: ./src/components/HeaderBreadcrumbs.js





// @mui

//



// ----------------------------------------------------------------------
HeaderBreadcrumbs.propTypes = {
    links: (prop_types_default()).array.isRequired,
    subtitle: (prop_types_default()).node,
    heading: (prop_types_default()).string,
    moreLink: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array
    ]),
    sx: (prop_types_default()).object
};
function HeaderBreadcrumbs(_param) {
    var links = _param.links, subtitle = _param.subtitle, heading = _param.heading, _moreLink = _param.moreLink, moreLink = _moreLink === void 0 ?  false || [] : _moreLink, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "subtitle",
        "heading",
        "moreLink",
        "sx"
    ]);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({}, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumbs, (0,_object_spread/* default */.Z)({
                        links: links
                    }, other)),
                    heading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                size: "small",
                                onClick: function() {
                                    return router.back();
                                },
                                sx: {
                                    mr: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                    icon: "fa-solid:arrow-left",
                                    sx: {
                                        width: 15,
                                        height: 15
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                component: "h1",
                                textTransform: "inherit",
                                children: heading
                            })
                        ]
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexShrink: 0,
                            pl: 8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: subtitle
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: isString_default()(moreLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: moreLink,
                    target: "_blank",
                    variant: "body2",
                    children: moreLink
                }) : moreLink.map(function(href) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        noWrap: true,
                        href: href,
                        variant: "body2",
                        target: "_blank",
                        sx: {
                            display: "table"
                        },
                        children: href
                    }, href);
                })
            })
        ]
    });
}


/***/ }),

/***/ 54543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ PostPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./src/redux/store.js + 11 modules
var store = __webpack_require__(74766);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/HeaderBreadcrumbs.js + 1 modules
var HeaderBreadcrumbs = __webpack_require__(991);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./src/layouts/index.js + 23 modules
var layouts = __webpack_require__(23954);
// EXTERNAL MODULE: ./src/redux/slices/blog/blog.comment.js
var blog_comment = __webpack_require__(29050);
// EXTERNAL MODULE: ./src/redux/slices/blog/blog.post.js + 1 modules
var blog_post = __webpack_require__(20246);
// EXTERNAL MODULE: ./src/routes/paths.js
var paths = __webpack_require__(76939);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(56254);
// EXTERNAL MODULE: ./src/components/FBSocial.js
var FBSocial = __webpack_require__(36239);
// EXTERNAL MODULE: ./src/components/Iconify.js + 1 modules
var Iconify = __webpack_require__(34444);
// EXTERNAL MODULE: ./src/components/Markdown.js + 1 modules
var Markdown = __webpack_require__(37943);
// EXTERNAL MODULE: ./src/hooks/useAuth.js
var useAuth = __webpack_require__(77364);
// EXTERNAL MODULE: ./src/service/blog/blog.bookmark.service.js
var blog_bookmark_service = __webpack_require__(73950);
// EXTERNAL MODULE: ./src/service/blog/blog.statistic.service.js
var blog_statistic_service = __webpack_require__(47562);
// EXTERNAL MODULE: ./src/utils/formatNumber.js
var formatNumber = __webpack_require__(87850);
// EXTERNAL MODULE: ./src/sections/comment/CommentList.js
var CommentList = __webpack_require__(16634);
// EXTERNAL MODULE: ./src/sections/comment/CommentNewForm.js
var CommentNewForm = __webpack_require__(79136);
// EXTERNAL MODULE: ./src/sections/blog/post/BlogPostTags.js
var BlogPostTags = __webpack_require__(6297);
;// CONCATENATED MODULE: ./src/sections/blog/post/PostDescription.js
/* eslint-disable react/prop-types */ /* eslint-disable react-hooks/exhaustive-deps */ 

















function PostDescription() {
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var isAuthenticated = (0,useAuth/* default */.Z)().isAuthenticated;
    var translate = (0,useLocales/* default */.Z)().translate;
    var post = (0,store/* useSelector */.v9)(function(state) {
        return state.blogPost;
    }).post;
    var ref = (0,react.useState)({
        viewNo: 0,
        likeNo: 0,
        commentNo: 0
    }), statistic = ref[0], setStatistic = ref[1];
    var ref1 = (0,react.useState)(null), bookmark = ref1[0], setBookmark = ref1[1];
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            updateView();
            getStatistic();
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        post === null || post === void 0 ? void 0 : post.id
    ]);
    var updateView = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                (0,blog_statistic_service/* updateViewAPI */._l)(post === null || post === void 0 ? void 0 : post.statistic.id);
                return [
                    2
                ];
            });
        });
        return function updateView() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLike = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var code;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAuthenticated) {
                            enqueueSnackbar(translate("label.signinToJmaster"), {
                                variant: "error"
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            (0,blog_statistic_service/* updateLikeAPI */.Sz)(post === null || post === void 0 ? void 0 : post.statistic.id)
                        ];
                    case 1:
                        code = _state.sent().code;
                        code === "200" && getStatistic();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLike() {
            return _ref.apply(this, arguments);
        };
    }();
    var getStatistic = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, code, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,blog_statistic_service/* getStatisticAPI */.CM)(post === null || post === void 0 ? void 0 : post.statistic.id)
                        ];
                    case 1:
                        ref = _state.sent(), code = ref.code, data = ref.data;
                        code === "200" && setStatistic(data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getStatistic() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var timeout = setTimeout(function() {
            isAuthenticated && isBookmarked();
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        post,
        isAuthenticated
    ]);
    var isBookmarked = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, code, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,blog_bookmark_service/* getBookmarkAPI */.FF)(post === null || post === void 0 ? void 0 : post.id)
                        ];
                    case 1:
                        ref = _state.sent(), code = ref.code, data = ref.data;
                        if (code === "200") setBookmark(data);
                        else setBookmark(null);
                        return [
                            2
                        ];
                }
            });
        });
        return function isBookmarked() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBookmark = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var code, request, ref, code1, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAuthenticated) {
                            enqueueSnackbar(translate("label.signinToJmaster"), {
                                variant: "error"
                            });
                            return [
                                2
                            ];
                        }
                        if (!bookmark) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,blog_bookmark_service/* deleteBookmarkAPI */.ad)(bookmark.id)
                        ];
                    case 1:
                        code = _state.sent().code;
                        if (code === "200") {
                            setBookmark(null);
                            enqueueSnackbar(translate("message.bookmarkCancel"));
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        request = {
                            post: {
                                id: post === null || post === void 0 ? void 0 : post.id
                            }
                        };
                        return [
                            4,
                            (0,blog_bookmark_service/* createBookmarkAPI */.GZ)(request)
                        ];
                    case 3:
                        ref = _state.sent(), code1 = ref.code, data = ref.data;
                        if (code1 === "200") {
                            setBookmark(data);
                            enqueueSnackbar(translate("message.bookmarkSuccess"));
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleBookmark() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 1,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h6",
                        children: post === null || post === void 0 ? void 0 : post.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        size: "small",
                        color: "default",
                        onClick: handleBookmark,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            icon: bookmark ? "material-symbols:bookmark" : "material-symbols:bookmark-outline",
                            width: 18,
                            height: 18
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FBSocial/* SocialShare */.Du, {
                        title: post === null || post === void 0 ? void 0 : post.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 0.8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "caption",
                                children: (0,formatNumber/* fShortenNumber */.v1)(statistic.viewNo)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "mdi:eye-outline",
                                sx: {
                                    height: 15,
                                    width: 15
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                sx: {
                    my: 1
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ql-snow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ql-editor",
                    style: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                        children: post === null || post === void 0 ? void 0 : post.description
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    my: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPostTags/* default */.Z, {
                        tags: post === null || post === void 0 ? void 0 : post.tags,
                        statistic: statistic,
                        handleLike: handleLike
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        children: translate("button.comment")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "subtitle2",
                        sx: {
                            color: "text.disabled"
                        },
                        children: [
                            "(",
                            statistic === null || statistic === void 0 ? void 0 : statistic.commentNo,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentNewForm/* default */.Z, {
                itemId: post === null || post === void 0 ? void 0 : post.id,
                type: "POST"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList/* default */.Z, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/blogs/[slug]/index.js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 




// next


// @mui











// ----------------------------------------------------------------------
var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingBottom: theme.spacing(10),
        paddingTop: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(12)
    });
});
PostPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function PostPage(param) {
    var currentItem = param.currentItem;
    var dispatch = (0,store/* useDispatch */.I0)();
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    var translate = (0,useLocales/* default */.Z)().translate;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.blogComment;
    }), searchComment = ref.search;
    (0,react.useEffect)(function() {
        dispatch((0,blog_post/* setPost */.Cd)(currentItem));
        dispatch((0,blog_comment/* setCommentSearch */.VG)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchComment), {
            value: "",
            page: 0,
            filterBys: {
                itemId: currentItem.id,
                type: "POST"
            }
        })));
    }, [
        currentItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: currentItem.title,
        description: currentItem.metaDescription,
        imagePath: currentItem.featureImage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RootStyle, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: themeStretch ? "xl" : "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBreadcrumbs/* default */.Z, {
                                links: [
                                    {
                                        name: translate("menu.hackerthon"),
                                        href: paths/* PATH_PAGE.home */.ko.home
                                    },
                                    {
                                        name: translate("menu.blog"),
                                        href: paths/* PATH_RESOURCE.blogs */.U6.blogs
                                    },
                                    {
                                        name: currentItem.title
                                    }, 
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    mb: 2
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostDescription, {})
                        ]
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 6297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BlogPostTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87918);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50480);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69368);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51107);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87952);
/* harmony import */ var _utils_formatNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87850);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25617);
/* harmony import */ var _components_Iconify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34444);
/* harmony import */ var _redux_slices_blog_blog_post__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20246);




// @mui

// utils

// components




// ----------------------------------------------------------------------
BlogPostTags.propTypes = {
    tags: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().array.isRequired),
    statistic: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object.isRequired),
    handleLike: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired)
};
function BlogPostTags(param) {
    var tags = param.tags, statistic = param.statistic, handleLike = param.handleLike;
    var ref;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var search = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.blogPost;
    }).search;
    var handleSelectTag = function(value) {
        var tags = [
            value
        ];
        var tagIds = tags === null || tags === void 0 ? void 0 : tags.map(function(t) {
            return t.id;
        }).toString();
        dispatch((0,_redux_slices_blog_blog_post__WEBPACK_IMPORTED_MODULE_5__/* .setPostSearch */ .g3)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, search), {
            page: 0,
            tags: tags,
            filterBys: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, search.filterBys), {
                tagIds: tagIds
            })
        })));
        router.push({
            pathname: "/blogs"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        sx: {
            py: 3
        },
        children: [
            tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    label: tag.title,
                    sx: {
                        m: 0.5
                    },
                    onClick: function() {
                        return handleSelectTag(tag);
                    }
                }, tag.id);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    mt: 3
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            onChange: handleLike,
                            defaultChecked: true,
                            size: "small",
                            color: "error",
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                icon: "eva:heart-fill"
                            }),
                            checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Iconify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                icon: "eva:heart-fill"
                            })
                        }),
                        label: (0,_utils_formatNumber__WEBPACK_IMPORTED_MODULE_1__/* .fShortenNumber */ .v1)(statistic === null || statistic === void 0 ? void 0 : statistic.likeNo)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        max: 5,
                        sx: {
                            "& .MuiAvatar-root": {
                                width: 32,
                                height: 32
                            }
                        },
                        children: statistic === null || statistic === void 0 ? void 0 : (ref = statistic.likers) === null || ref === void 0 ? void 0 : ref.map(function(person) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                alt: person.displayName,
                                src: person.photoURL
                            }, person.displayName);
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 16634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommentList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(153);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10633);
/* harmony import */ var _components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77251);
/* harmony import */ var _components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37549);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29050);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74766);
/* harmony import */ var _CommentItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83741);
/* eslint-disable react-hooks/exhaustive-deps */ 



// @mui







// ----------------------------------------------------------------------
function CommentList() {
    var dispatch = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().translate;
    var ref = (0,_redux_store__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.blogComment;
    }), comments = ref.comments, totalPages = ref.totalPages, isLoading = ref.isLoading, search = ref.search, numberOfElements = ref.numberOfElements;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("0"), sortBy = ref1[0], setSortBy = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeout = setTimeout(function() {
            dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .getComments */ .li)());
        }, 500);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        search
    ]);
    var handleChangePage = function(_, value) {
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: value - 1
        })));
    };
    var handleChangeSort = function(event) {
        var value = event.target.value;
        var orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        if (value === "0") orders = [
            {
                order: "desc",
                property: "createdAt"
            }
        ];
        else if (value === "1") orders = [
            {
                order: "asc",
                property: "createdAt"
            }
        ];
        else orders = [
            {
                order: "desc",
                property: "likeNo"
            }
        ];
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_5__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, search), {
            page: 0,
            orders: orders
        })));
        setSortBy(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        my: 1,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        variant: "caption",
                        children: [
                            translate("label.sortBy"),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        variant: "standard",
                        value: sortBy,
                        size: "small",
                        sx: {
                            fontSize: 12,
                            fontWeight: "bold",
                            ml: 1,
                            pt: 1
                        },
                        disableUnderline: true,
                        onChange: handleChangeSort,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "0",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByNew")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "1",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByOld")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                value: "2",
                                sx: {
                                    fontSize: 12
                                },
                                children: translate("label.sortByLike")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                spacing: 2,
                children: [
                    comments.map(function(comment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommentItem__WEBPACK_IMPORTED_MODULE_7__/* .CommentItemWrapper */ .w, {
                            comment: comment
                        }, comment.id);
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton_SkeletonItem__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonCommentItem */ .bG, {}) : numberOfElements == 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EmptyContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: " ",
                        description: translate("hackerthon.exercise.noComment")
                    })
                ]
            }),
            numberOfElements > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                alignItems: "center",
                my: 1.5,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    count: totalPages,
                    variant: "text",
                    page: search.page + 1,
                    onChange: handleChangePage
                })
            })
        ]
    });
}


/***/ }),

/***/ 47562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CM": function() { return /* binding */ getStatisticAPI; },
/* harmony export */   "Sz": function() { return /* binding */ updateLikeAPI; },
/* harmony export */   "_l": function() { return /* binding */ updateViewAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var _utils_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92369);



var getStatisticAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var config;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            config = {
                url: "/statistic/".concat(id),
                method: "GET"
            };
            return [
                2,
                (0,_utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .handleRequestBlog */ .p)(config)
            ];
        });
    });
    return function getStatisticAPI(id) {
        return _ref.apply(this, arguments);
    };
}();
var updateViewAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var config;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            config = {
                url: "/statistic/".concat(id, "/view"),
                method: "PUT"
            };
            return [
                2,
                (0,_utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .handleRequestBlog */ .p)(config)
            ];
        });
    });
    return function updateViewAPI(id) {
        return _ref.apply(this, arguments);
    };
}();
var updateLikeAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var config;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            config = {
                url: "/statistic/".concat(id, "/like"),
                method: "PUT"
            };
            return [
                2,
                (0,_utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .handleRequestBlog */ .p)(config)
            ];
        });
    });
    return function updateLikeAPI(id) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,6429,135,1556,633,2953,2856,6805,733,3741,9774,2888,179], function() { return __webpack_exec__(43581); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);